// src/pages/CalculoHonorarios/components/ListagemHonorarios.js

import React from 'react';

const ListagemHonorarios = ({ 
  honorarios, 
  onVisualizar, 
  onEditar, 
  onExcluir, 
  loading 
}) => {
  if (loading && honorarios.length === 0) {
    return (
      <div className="loading-honorarios">
        <span>⏳</span>
        <span>Carregando honorários...</span>
      </div>
    );
  }

  if (honorarios.length === 0) {
    return (
      <div className="no-honorarios">
        <span>💰</span>
        <p>Nenhum honorário cadastrado</p>
        <p className="hint">Clique em "➕ NOVO CÁLCULO" para começar</p>
      </div>
    );
  }

  const resolverNomeCliente = (hon) => {
    if (hon.nome_cli) return hon.nome_cli;
    if (hon.cod_cli) return `#${hon.cod_cli}`;
    return '-';
  };

  return (
    <div className="honorarios-list">
      <h3>💼 Cálculos de Honorários ({honorarios.length})</h3>

      <div className="honorarios-table">
        <div className="table-header">
          <div className="table-cell">ID</div>
          <div className="table-cell">Cliente</div>
          <div className="table-cell">Descrição</div>
          <div className="table-cell">Horas</div>
          <div className="table-cell">Valor/h</div>
          <div className="table-cell">Base</div>
          <div className="table-cell">Cálculos</div>
          <div className="table-cell">Último Cálculo</div>
          <div className="table-cell">Ações</div>
        </div>

        {honorarios.map(hon => {
          const totalHoras = parseFloat(hon.base_total_horas) || 0;
          const valorHora = parseFloat(hon.base_valor_hora) || 0;
          const valorBase = totalHoras * valorHora;
          
          return (
            <div key={hon.id} className="table-row">
              <div className="table-cell">{hon.id}</div>
              <div className="table-cell">{resolverNomeCliente(hon)}</div>
              <div className="table-cell descricao-cell">
                {hon.descricao_servico?.substring(0, 60)}
                {hon.descricao_servico?.length > 60 ? '...' : ''}
              </div>
              <div className="table-cell">{totalHoras}h</div>
              <div className="table-cell">{valorHora.toFixed(2)}€</div>
              <div className="table-cell valor-destaque">{valorBase.toFixed(2)}€</div>
              <div className="table-cell">{hon.total_calculos || 0}</div>
              <div className="table-cell">
                {hon.ultimo_calculo 
                  ? new Date(hon.ultimo_calculo).toLocaleDateString('pt-PT')
                  : '-'
                }
              </div>
              <div className="table-cell">
                <div className="row-actions">
                  <button
                    className="mini-btn view-btn"
                    onClick={() => onVisualizar(hon)}
                    title="Visualizar cálculo"
                  >
                    👁️
                  </button>
                  <button
                    className="mini-btn edit-btn"
                    onClick={() => onEditar(hon)}
                    disabled={loading}
                    title="Editar honorário"
                  >
                    ✏️
                  </button>
                  <button
                    className="mini-btn delete-btn"
                    onClick={() => onExcluir(hon.id, hon.descricao_servico)}
                    disabled={loading}
                    title="Excluir honorário"
                  >
                    🗑️
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ListagemHonorarios;